import * as React from 'react'

import { Alert, Box, Icon, Text } from '@factorialco/deprecated-design-system'
import { PerformanceEvaluationEstimatedScoreFieldsFragment } from 'generated/resources/graphql'

import i18n from 'modules/core/lib/i18n'

export const EstimatedScore: React.FC<{
  estimatedScore: PerformanceEvaluationEstimatedScoreFieldsFragment | null
  submittingEstimateScore: boolean
}> = ({ estimatedScore, submittingEstimateScore }) => {
  return (
    <Alert color="note">
      <Box flexNoShrink flexDirection="row">
        {submittingEstimateScore ? (
          <>
            <Icon.Medium icon="spinner" />
            <Text.Normal>
              {i18n.t('performance_process.reviews.answer_evaluation.estimated_score.submitting')}
            </Text.Normal>
          </>
        ) : (
          <>
            <Icon.Medium icon="calculator" />
            <Text.Normal>
              {i18n.t('performance_process.reviews.answer_evaluation.estimated_score.title', {
                score: estimatedScore?.score?.toString() ?? '-',
                max_scale: estimatedScore?.scaleMax?.toString() ?? '-',
              })}
            </Text.Normal>
          </>
        )}
      </Box>
    </Alert>
  )
}
